const exclusionCookieName = 'swipekit_posthog_excluded';
const internalEmails = ['shashwat.amin@yahoo.com', 'shash122tfu@gmail.com'];
const botPattern = /bot|crawler|spider|headless|preview|slurp/i;

function normalizeEmail(email = '') {
	return String(email).trim().toLowerCase();
}

function isInternalEmail(email = '') {
	const normalizedEmail = normalizeEmail(email);
	const parts = normalizedEmail.split('@');

	return parts[0] === 'shash' || parts[1] === 'monospace.site' || internalEmails.includes(normalizedEmail);
}

function isBotBrowser(navigatorObject = {}) {
	return navigatorObject.webdriver === true || botPattern.test(String(navigatorObject.userAgent || ''));
}

function hasExclusionCookie(cookie = '') {
	const cookies = String(cookie).split(';');

	for (let i = 0; i < cookies.length; i += 1) {
		if (cookies[i].trim() === `${exclusionCookieName}=1`) {
			return true;
		}
	}

	return false;
}

function setExclusionCookie(documentObject, locationObject) {
	if (!documentObject) {
		return;
	}

	let cookie = `${exclusionCookieName}=1; Max-Age=31536000; Path=/; SameSite=Lax`;
	const hostname = String((locationObject && locationObject.hostname) || '');

	if (hostname === 'swipekit.app' || hostname.endsWith('.swipekit.app')) {
		cookie += '; Domain=.swipekit.app; Secure';
	}

	documentObject.cookie = cookie;
}

function excludeBrowser(posthog, email, documentObject, locationObject) {
	const excluded = isInternalEmail(email) || hasExclusionCookie((documentObject && documentObject.cookie) || '');

	if (!excluded) {
		return false;
	}

	setExclusionCookie(documentObject, locationObject);
	posthog.reset();
	posthog.opt_out_capturing();
	return true;
}

function getReferringDomain(referrer = '') {
	if (!referrer) {
		return '';
	}

	try {
		return new URL(referrer).hostname;
	} catch (err) {
		return '';
	}
}

function extractFirstTouch(url, referrer = '', affiliateCode = '') {
	const currentUrl = new URL(url);
	const query = currentUrl.searchParams;
	const properties = {
		initial_landing_url: currentUrl.href,
		initial_landing_path: currentUrl.pathname,
		initial_referrer: referrer || '',
		initial_referring_domain: getReferringDomain(referrer),
	};
	const queryProperties = {
		utm_source: 'initial_utm_source',
		utm_medium: 'initial_utm_medium',
		utm_campaign: 'initial_utm_campaign',
		utm_content: 'initial_utm_content',
		utm_term: 'initial_utm_term',
		gclid: 'initial_gclid',
		fbclid: 'initial_fbclid',
	};

	Object.keys(queryProperties).forEach((key) => {
		const value = query.get(key);
		if (value) {
			properties[queryProperties[key]] = value;
		}
	});

	const referral = affiliateCode || query.get('via') || query.get('affonso_referral');
	if (referral) {
		properties.initial_affiliate_code = referral;
	}

	return properties;
}

function identifyUser(posthog, user, workspace, documentObject, locationObject) {
	if (!user || !user.id) {
		return false;
	}

	if (excludeBrowser(posthog, user.email, documentObject, locationObject)) {
		return false;
	}

	posthog.identify(String(user.id));

	const workspaceId = (workspace && workspace.id) || user.workspaceId;
	if (workspaceId) {
		posthog.group('workspace', String(workspaceId), {
			workspaceId,
		});
	}

	return true;
}

export {
	exclusionCookieName,
	normalizeEmail,
	isInternalEmail,
	isBotBrowser,
	hasExclusionCookie,
	setExclusionCookie,
	excludeBrowser,
	getReferringDomain,
	extractFirstTouch,
	identifyUser,
};
